<nav class="breadcrumb">
    @for (breadcrumb of breadcrumbs(); track $index) {
        @if ($last) {
            <span class="cursor-default">{{ breadcrumb.label | translate }}</span>
        } @else {
            <a class="cursor-pointer no-underline inactive-route"
               [routerLink]="breadcrumb.url">{{ breadcrumb.label | translate }}</a>
            <span class="separator inactive-route cursor-default">/</span>
        }
    } @empty {
        <span>{{ 'BREADCRUMB.EMPTY' | translate }}</span>
    }
</nav>
